import { IGuardianResponse } from '../domain/guardian.entities';
import { IGuardianGateway} from '../domain/guardian.gateway';
export class FindUseCase {
  constructor(private findGate: IGuardianGateway) {}
  async execute(cpf: string): Promise<IGuardianResponse | undefined> {
    const replacedCpf = cpf.replace(/\D/g, '');
    if (replacedCpf.length < 11) return
    return await this.findGate.searchByCpf(cpf);
  }
}